<template>
  <div class="home">
    <div class="header">
      <h1>
        <a
          href="//scjg.hubei.gov.cn/index.shtml"
          class="nt"
          style="width: 100%"
          title=""
        ></a>
      </h1>
      <div class="search-form">
        <h2></h2>
        <el-form :model="queryForm" label-width="150px">
          <el-row
            :gutter="20"
            type="flex"
            style="flex-wrap: wrap"
            class="flex-row"
          >
            <el-col class="wat">
              <el-form-item label="身份证号：">
                <el-input
                  v-model="queryForm.zsbh"
                  placeholder="请输入身份证号"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="wat">
              <el-form-item label="姓名：">
                <el-input
                  v-model="queryForm.xm"
                  placeholder="请输入姓名"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row type="flex" style="flex-wrap: wrap" class="flex-row">
          <el-col class="wat">
            <el-button
              @click="clickQuery"
              class="search-btn cx"
              type="primary"
              style="width: 40%"
              >查 询</el-button
            >
            <el-button
              @click="resetQuery"
              class="search-btn cz"
              type="info"
              style="width: 40%"
              >重 置</el-button
            >
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" header-row-class-name="tab-head">
        <el-table-column prop="XM" label="姓名" align="center">
        </el-table-column>
        <el-table-column prop="ZSBH" label="证书编号" align="center">
        </el-table-column>
        <el-table-column prop="FZJG" label="发证机构" align="center">
        </el-table-column>
        <el-table-column prop="PZRQ" label="批准日期" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="btnClick(scope.row)"
              >电子证书</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty"> 未查询到数据 </template>
      </el-table>
    </div>
    <div class="pagesall">
      <div class="page-total">
        <span>
          共
          <span class="total">{{ allTotal }}</span>
          条
        </span>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :total="pageTotal"
        :current-page="queryPage.currentPage"
        :page-sizes="[10, 50, 100]"
        :page-size="queryPage.pageSize"
        layout="prev, pager, next, sizes, jumper"
        style="margin-bottom: 20px"
      >
      </el-pagination>
    </div>
    <iframe
      src="https://scjg.hubei.gov.cn/fzlm/qtlm/yw/index.shtml"
      frameborder="0"
      style="width: 100%; height: 202px"
    ></iframe>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import http from "@/http/index.js";
export default {
  name: "Home",
  // components: {
  //   HelloWorld
  // }
  data() {
    return {
      queryForm: {
        xm: "",
        // tyshxydm: '',
        // fzjg: '',
        zsbh: "",
      },
      queryPage: {
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [],
      pageTotal: 0,
      allTotal: 0,
      zsmc: "",
      isParmasQuery: false,
    };
  },
  created() {},
  mounted() {
    this.initQury();
    this.setTotal();
  },
  methods: {
    async setTotal() {
      const req = {
        pageSize: this.queryPage.pageSize,
        currentPage: this.queryPage.currentPage,
      };

      const param = JSON.stringify(req);
      const findDgsLicListResp = await http.user.findDgsLicList({
        param,
        method: "POST",
      });
      const { code, content } = await http.user.tzsbzyryAllNum(
        req,
        findDgsLicListResp
      );
      if (code == true || code == 200) {
        this.allTotal = content[0]["COUNT(1)"];
      }
    },
    // 初始化查询
    async initQury() {
      this.isParmasQuery = false;
      const req = {
        pageSize: this.queryPage.pageSize,
        currentPage: this.queryPage.currentPage,
      };
      const param = JSON.stringify(req);
      const findDgsLicListResp = await http.user.findDgsLicList({
        param,
        method: "POST",
      });
      const { code, content, totalSize } = await http.user.licmaininfo(
        req,
        findDgsLicListResp
      );
      // code有数字和true的情况
      if (code == true || code == 200) {
        this.tableData = content;
        this.pageTotal = totalSize;
      }
    },
    // 分页
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.queryPage.pageSize = val;
      if (!this.isParmasQuery) {
        this.initQury();
      } else {
        this.queryPamarSwarch();
      }
    },
    // 分页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.queryPage.currentPage = val;
      if (!this.isParmasQuery) {
        this.initQury();
      } else {
        this.queryPamarSwarch();
      }
    },
    // 重置查询
    resetQuery() {
      this.queryPage = this.$options.data().queryPage;
      this.queryForm = this.$options.data().queryForm;
      this.initQury();
    },
    // 按钮事件
    btnClick(data, type) {
      this.$alert(
        "根据网络安全管理要求，暂无法查看电子证书。待系统优化后可再查询。不便之处，敬请谅解！",
        "提示",
        {
          confirmButtonText: "确定",
          callback: (action) => {},
        }
      );
      return;
      window.open(data.ZB);
    },
    // 点击查询初始化
    async queryPamarSwarch() {
      const req = {
        // zsmc: this.zsmc,
        pageSize: this.queryPage.pageSize,
        currentPage: this.queryPage.currentPage,
        zsbh: this.queryForm.zsbh,
        xm: this.queryForm.xm,
        // tyshxydm: this.queryForm.tyshxydm,
        // qymc: `%${this.queryForm.qymc}%`,
        // fzjg: this.queryForm.fzjg
      };

      const param = JSON.stringify(req);
      const findDgsLicListResp = await http.user.findDgsLicList({
        param,
        method: "POST",
      });
      const { code, content, totalSize } = await http.user.licmaininfobyparam(
        req,
        findDgsLicListResp
      );
      if (code == true || code == 200) {
        this.tableData = content;
        this.pageTotal = totalSize;
      }
    },
    // 点击查询
    async clickQuery() {
      this.isParmasQuery = true;
      this.queryPage.pageSize = 10;
      this.queryPage.currentPage = 1;
      this.queryPamarSwarch();
    },
  },
};
</script>
<style>
@media (max-width: 1200px) {
  body {
    width: 980px;
  }
  :v-deep .table {
    width: 980px;
  }
  .search-form {
    height: 375px !important;
  }
  .jc {
    top: 71% !important;
    right: 90px !important;
  }
  .gov {
    top: 70% !important;
    right: 0px !important;
  }
  .search-form h2 {
    background-size: 100% !important;
  }
  input::placeholder {
    font-size: 12px;
  }
}
</style>
<style scoped>
body {
  background-color: #fff;
}
.header h1 {
  width: 100%;
  height: 70px;
  background: linear-gradient(to bottom, #f2faff, #f3faff);
  box-shadow: 0px 0px 20px rgba(2, 60, 132, 0.3);
  z-index: 999;
  position: relative;
}

.header h1 a {
  display: block;
  height: 70px;
  background: url(//scjg.hubei.gov.cn/material/images/xkzcx_logo.png) 17px 50%
    no-repeat;
}
.search-form {
  width: 100%;
  height: 300px;
  margin-bottom: 37px;
  background: url(//scjg.hubei.gov.cn/material/images/xkzcx_bg.jpg) 50% 100%
    no-repeat;
  overflow: hidden;
}
.search-form h2 {
  width: 100%;
  height: 90px;
  background: url(//scjg.hubei.gov.cn/material/images/scjgcx/tzsbzyry.png) 50%
    50% no-repeat;
  margin-top: 36px;
  margin-bottom: 19px;
}
::v-deep .tab-head {
  background: #edf6fe;
  color: #224b7f;
  line-height: 60px;
}
::v-deep .tab-head th {
  padding: 0px;
  background: #edf6fe;
  border-bottom: none !important;
}
::v-deep .flex-row {
  display: flex;
  justify-content: center;
  width: 100%;
}
::v-deep .el-form-item {
  display: flex;
  align-items: center;
}
::v-deep .el-form-item__label {
  width: auto !important;
  font-size: 18px;
  color: #333;
}
::v-deep .el-form-item__content {
  margin-left: 0px !important;
}
::v-deep .wat {
  width: auto;
}
::v-deep .el-input__inner {
  border: 1px solid #6b9eec;
  border-radius: 0px;
}
::v-deep .el-input__inner::placeholder {
  color: #666666;
}
::v-deep .search-btn {
  width: 96px !important;
  height: 42px;
  border-radius: 0px;
  color: #fff;
  border: none;
}
::v-deep .cx {
  background-color: #002f7c;
}
::v-deep .cz {
  background-color: #fd844e;
  margin-left: 20px;
}
::v-deep .el-pagination__sizes {
  margin: 0 0 0 10px;
}
::v-deep .detail-dialog .el-dialog__header {
  padding: 16px 24px;
  border-bottom: 1px solid rgba(5, 5, 5, 0.06);
  text-align: left;
}
::v-deep .detail-dialog .el-dialog__body {
  padding: 24px;
}
.scroll-container {
  padding: 6px;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.scrollbar__wrap {
  overflow-x: hidden;
  scrollbar-width: none;
  height: 100%;
  overflow: auto;
}
.table-box {
  height: 500px;
}
.my-table {
  width: 100%;
  table-layout: fixed;
  border-left: 1px solid #f0f0f0;
  border-top: 1px solid #f0f0f0;
}
.my-table > tr > th,
.my-table > thead > tr > th,
.my-table > tbody > tr > th,
.my-table > tfoot > tr > th,
.my-table > tr > td,
.my-table > thead > tr > td,
.my-table > tbody > tr > td,
.my-table > tfoot > tr > td {
  padding: 8px;
  border-right: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
}
.my-table > tr:nth-child(2n),
.my-table > tbody > tr:nth-child(2n) {
  background-color: #fafafa;
}
::v-deep .el-table tr:nth-child(2n) {
  background-color: #fafafa;
}
.font-600 {
  font-weight: 600;
}
.text-left {
  text-align: left;
}
.text-blue {
  color: #0986b0;
}
.pagesall {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
}
.page-total {
  height: 32px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.nt {
  text-align: left;
  letter-spacing: -3em;
  overflow: hidden;
}

.header-title {
  font-size: 17pt;
  font-weight: 600;
  margin-top: 30px;
  color: rgb(19, 90, 156);
}

.table {
  margin-top: 50px;
  margin-bottom: 50px;
  width: 100%;
}
</style>
